export default __webpack_public_path__ + "static/home-sugar-free-caramel-macadamia-ice-cream-194398adf76987918d5aa59d6b8b09d1.png";